<template>
	<ui-dialog
		ref="dialog"
		:title="title"
		class="stream-share-dialog"
		closable
	>
		<ui-input
			v-model="password"
			autocomplete="new-password"
			autofocus
			label="Link password (optional)"
			type="password"
		/>
		<span class="ui-subheading">Share by</span>
		<ui-tabs>
			<md-tab class="ui-tab--reset-padding" md-label="Link">
				<share-link
					:password="password"
					:stream-id="streamId"
				/>
			</md-tab>
			<md-tab class="ui-tab--reset-padding" md-label="E-mail">
				<share-email
					:password="password"
					:stream-id="streamId"
					@send="$refs.dialog.close()"
				/>
			</md-tab>
		</ui-tabs>
	</ui-dialog>
</template>

<script>
import UiDialog from "lib/components/ui/Dialog";
import UiInput from "lib/components/ui/Input";
// import UiTab from "lib/components/ui/Tab";
import UiTabs from "lib/components/ui/Tabs";
import ShareLink from "components/stream/ShareLink";
import ShareEmail from "components/stream/ShareEmail";

export default {
	name: "StreamShareDialog",
	components: {
		UiDialog,
		UiInput,
		// UiTab,
		UiTabs,
		ShareLink,
		ShareEmail
	},
	data() {
		return {
			password: "",
			streamId: "",
			title: ""
		};
	},
	mounted() {
		this.open = (stream) => {
			this.password = "";
			this.streamId = stream.stream_id;
			this.title = `Share stream - ${stream.title}`;
			this.$refs.dialog.open();
		};
	}
};
</script>

<style scoped>
.ui-tab--reset-padding {
	padding-left: 0;
	padding-right: 0;
	padding-bottom: 0;
}
</style>
